import React from 'react';
import PropTypes from 'prop-types';
import { Space, Row, Col, Drawer, Typography, Descriptions } from 'antd';
import { CloseIcon, CopyIcon } from 'utils/icons';
import currencyFormat from 'utils/currencyFormat';
import dayjs from 'dayjs';

function TransactionDetailsDrawer({ productList, viewMoreModal, currentView, handleViewMore }) {
  const detailsItems = [
    {
      label: 'Date of Transaction',
      key: 'transaction_ist_date',
      formatter: (value) => dayjs(value).format('DD MMM, YYYY')
    },
    {
      label: 'Product Info',
      key: 'app_name',
      formatter: (value) => productList[value]?.label
    },
    {
      label: 'Amount',
      key: 'transaction_amount',
      formatter: (value) => currencyFormat(value, true, true)
    },
    {
      label: 'Partner Commission Mode',
      key: 'partner_commission_type'
    },
    {
      label: 'Partner Commission Value',
      key: 'partner_commission',
      formatter: (value) => parseFloat(value).toFixed(2)
    },
    {
      label: 'Partner Commission Amount',
      key: 'partner_commission_amount',
      formatter: (value) => currencyFormat(value, true, true)
    },
    {
      label: 'Service Charge',
      key: 'transaction_markup_charge',
      formatter: (value) => currencyFormat(value, true, true)
    },
    {
      label: 'Service Tax',
      key: 'transaction_markup_charge_tax',
      formatter: (value) => currencyFormat(value, true, true)
    },
    {
      label: 'Merchant Settlement Amount',
      key: 'merchant_settlement_amount',
      formatter: (value) => currencyFormat(value, true, true)
    }
  ];

  const merchantSpecificParameters = [
    {
      label: 'UDF 1',
      key: 'udf1'
    },
    {
      label: 'UDF 2',
      key: 'udf2'
    },
    {
      label: 'UDF 3',
      key: 'udf3'
    },
    {
      label: 'UDF 4',
      key: 'udf4'
    },
    {
      label: 'UDF 5',
      key: 'udf5'
    },
    {
      label: 'UDF 6',
      key: 'udf6'
    },
    {
      label: 'UDF 7',
      key: 'udf7'
    },
    {
      label: 'UDF 8',
      key: 'udf8'
    },
    {
      label: 'UDF 9',
      key: 'udf9'
    },
    {
      label: 'UDF 10',
      key: 'udf10'
    }
  ];

  const renderDescriptionItems = (items) => {
    return items.map((item) => {
      const formatted = item.formatter
        ? item.formatter(currentView?.[item.key])
        : currentView?.[item.key];

      return (
        <Descriptions.Item key={item.key} label={item.label}>
          {formatted || '-'}
        </Descriptions.Item>
      );
    });
  };

  return (
    <Drawer
      title={
        <CloseIcon
          style={{
            fontSize: '30px',
            color: 'var(--color-primary)',
            position: 'absolute',
            top: '30px',
            left: '-16px',
            cursor: 'pointer'
          }}
          onClick={() => handleViewMore(false)}
        />
      }
      placement="right"
      width={550}
      closable={false}
      open={viewMoreModal}
      rootClassName="payout-drawer"
    >
      <Row>
        <Col span={24}>
          <Space direction="horizontal" style={{ width: '100%' }}>
            <>
              <Typography.Title level={4} style={{ margin: '0' }}>
                Easebuzz ID -
              </Typography.Title>
              <Typography.Text
                copyable={{
                  icon: <CopyIcon style={{ color: 'var(--color-primary)' }} />
                }}
              >
                {currentView?.app_transaction_id}
              </Typography.Text>
            </>
          </Space>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Descriptions
            title="Transaction Details"
            size="small"
            bordered
            column={1}
            style={{ marginTop: '20px' }}
          >
            {renderDescriptionItems(detailsItems)}
          </Descriptions>

          <Descriptions
            title="Merchant Specific Parameters"
            size="small"
            bordered
            column={1}
            style={{ marginTop: '20px' }}
          >
            {renderDescriptionItems(merchantSpecificParameters)}
          </Descriptions>
        </Col>
      </Row>
    </Drawer>
  );
}

TransactionDetailsDrawer.propTypes = {
  viewMoreModal: PropTypes.bool.isRequired,
  productList: PropTypes.arrayOf.isRequired,
  currentView: PropTypes.arrayOf.isRequired,
  handleViewMore: PropTypes.func.isRequired
};

export default TransactionDetailsDrawer;
